var _defs, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconawesomeTwitterSquare(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 18.963,
    height: 18.962,
    viewBox: "0 0 18.963 18.962",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#094674"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#05233a"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-twitter-square",
    "data-name": "Icon awesome-twitter-square",
    d: "M16.931,2.25H2.032A2.032,2.032,0,0,0,0,4.282v14.9a2.032,2.032,0,0,0,2.032,2.032h14.9a2.032,2.032,0,0,0,2.032-2.032V4.282A2.032,2.032,0,0,0,16.931,2.25Zm-2.07,6.722c.008.119.008.241.008.36a7.844,7.844,0,0,1-7.9,7.9,7.862,7.862,0,0,1-4.262-1.244,5.849,5.849,0,0,0,.669.034,5.566,5.566,0,0,0,3.445-1.185,2.78,2.78,0,0,1-2.595-1.926,2.992,2.992,0,0,0,1.253-.051,2.776,2.776,0,0,1-2.222-2.726V10.1a2.774,2.774,0,0,0,1.253.351A2.77,2.77,0,0,1,3.276,8.138a2.741,2.741,0,0,1,.377-1.4,7.882,7.882,0,0,0,5.723,2.9A2.782,2.782,0,0,1,14.112,7.1a5.44,5.44,0,0,0,1.761-.669,2.769,2.769,0,0,1-1.219,1.528,5.524,5.524,0,0,0,1.6-.432A5.843,5.843,0,0,1,14.861,8.972Z",
    transform: "translate(0 -2.25)",
    fill: "url(#linear-gradient)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconawesomeTwitterSquare);
export default __webpack_public_path__ + "static/media/Icon awesome-twitter-square.82fb9990751483884588d0912dd46527.svg";
export { ForwardRef as ReactComponent };